// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOW_DOES_IT_WORK = "Ako to funguje?";
